import React, { useState } from "react";
import { motion } from "framer-motion";
import emailjs from "emailjs-com";

// icons / assets
import linkedInLogo from "../assets/greylinkedin-removebg-preview.png";
import resumeLogo from "../assets/grey_cv_background-removebg-preview.png";
import resumePdf from "../assets/Riyasat Ahmed .docx.pdf"; // make sure this path & name match

const Contact = () => {
  const [formData, setFormData] = useState({
    from_name: "",
    from_email: "",
    message: ""
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setIsSubmitting(true);
    setError(null);
    setSuccess(null);

    const serviceID  = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey  = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    emailjs
      .send(serviceID, templateID, formData, publicKey)
      .then((response) => {
        console.log("SUCCESS!", response.status, response.text);
        setSuccess(`Thanks ${formData.from_name}, your message has been sent!`);
        setFormData({ from_name: "", from_email: "", message: "" });
      })
      .catch((err) => {
        console.error("FAILED...", err);
        setError("Something went wrong. Please try again later.");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <section id="contact">
      <motion.h3
        initial={{ y: 20, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        Let's work together
      </motion.h3>

      <motion.p
        className="contact-subtitle"
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        If you have a project, internship, or just want to connect, send a
        message below.
      </motion.p>

      {/* LinkedIn + Resume logos row */}
      <div className="contact-links">
        <a
          href="https://www.linkedin.com/in/riyasat-ahmed-81b31a316/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={linkedInLogo}
            alt="LinkedIn"
            className="contact-icon-img"
          />
        </a>

        <a
          href={resumePdf}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={resumeLogo}
            alt="Resume"
            className="contact-icon-img"
          />
        </a>
      </div>

      <motion.div
        className="contact"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        {success && (
          <p className="form-feedback form-success">{success}</p>
        )}
        {error && <p className="form-feedback form-error">{error}</p>}

        <form onSubmit={handleSubmit}>
          <div className="contact-grid">
            <input
              type="text"
              name="from_name"
              placeholder="Your name"
              value={formData.from_name}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="from_email"
              placeholder="Your email"
              value={formData.from_email}
              onChange={handleChange}
              required
            />
          </div>

          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
            required
            rows="5"
          />

          <motion.button
            className="btn btn-primary contact-submit"
            type="submit"
            disabled={isSubmitting}
            whileHover={{ scale: isSubmitting ? 1 : 1.05 }}
            whileTap={{ scale: isSubmitting ? 1 : 0.95 }}
          >
            {isSubmitting ? "Sending..." : "Send Message"}
          </motion.button>
        </form>
      </motion.div>
    </section>
  );
};

export default Contact;
